const routes = {
	base: '/personal-cabinet',
	knowledgeBase: '/personal-cabinet/knowledge-base',
	knowledgeBase__article: '/personal-cabinet/knowledge-base/:knowledgeId',
	knowledgeBase__theme: '/personal-cabinet/knowledge-base/theme/:themeId',
	learning: '/personal-cabinet/learning',
	learning__tab: '/personal-cabinet/learning/:tab',
	notifications: '/personal-cabinet/notifications',
	notifications__item: '/personal-cabinet/notifications/:notificationId',
};

export default routes;
